"use client"
import styled from "@emotion/styled"
import { Button } from "@mui/material"
import Link from "next/link"
import { Desktop, Mobile, NewText, useIsDesktop } from "ui"
import { getUmbracoPDFUrl } from "utils"
import { extractProperty } from "utils/extractProperty"

const StyledContainer = styled.div`
  margin: 32px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
  flex-direction: column;

  ${(props) => props.theme.breakpoints.up("md")} {
    margin: 40px auto;
    margin-bottom: 80px;
    width: fit-content;
    flex-direction: row;
    gap: 24px;
  }
`

type Props = {
  data: any
}
const ButtonsComponent = ({ data }: Props) => {
  const read = extractProperty(data, "read")
  const watch = extractProperty(data, "watch")
  const watchFull = extractProperty(data, "watchFull")
  const isDesktop = useIsDesktop()

  return (
    <StyledContainer>
      {read[0] && (
        <Link
          href={getUmbracoPDFUrl(read[0]?.url) || ""}
          target={"_blank"}
          style={{
            textDecoration: "none",
            marginInlineEnd: isDesktop && watch[0] && watchFull[0] ? "71px" : 0,
          }}
        >
          <NewText
            desktopFontSize={16}
            desktopFontWeight="400"
            desktopLineHeight="100%"
            mobileFontSize={14}
            mobileFontWeight="400"
            mobileLineHeight={"125%"}
            component="h1"
            color={"black"}
          >
            {read[0]?.name}
          </NewText>
        </Link>
      )}
      {watch[0] && (
        <Link
          href={watch[0]?.url || ""}
          target={watch[0]?.target}
          style={{ textDecoration: "none" }}
        >
          <Desktop>
            <Button variant="outlined" size="large">
              {watch[0]?.name}
            </Button>
          </Desktop>
          <Mobile>
            <Button variant="outlined" size="medium">
              {watch[0]?.name}
            </Button>
          </Mobile>
        </Link>
      )}
      {watchFull[0] && (
        <Link
          href={watchFull[0]?.url || ""}
          target={watchFull[0]?.target}
          style={{ textDecoration: "none" }}
        >
          <Desktop>
            <Button variant="outlined" size="large">
              {watchFull[0]?.name}
            </Button>
          </Desktop>
          <Mobile>
            <Button variant="outlined" size="medium">
              {watchFull[0]?.name}
            </Button>
          </Mobile>
        </Link>
      )}
    </StyledContainer>
  )
}
export default ButtonsComponent
